import { Artifact } from '../types';

export const INITIAL_ARTIFACTS: Artifact[] = [
  {
    id: 0,
    title: 'Bình Phong',
    en: 'Standing Screen',
    author: 'Nguyễn Gia Trí',
    material: 'Sơn mài',
    code: '15',
    location: 'Phòng trưng bày Mỹ thuật hiện đại · Mẫu',
    stamp: '/images/generated/stamps-v5/stamp-binh-phong-v5.webp',
    source: 'https://vnfam.vn/vi/hiện-vật/5af4ffa0384627001c4760f7',
    unlocked: true,
    story: 'Một sáng tác sơn mài quy mô lớn của Nguyễn Gia Trí. Các mảng nhân vật và thiên nhiên cho thấy khả năng tổ chức không gian trang trí giàu nhịp điệu. Tác phẩm là một trong những kiệt tác sơn mài đỉnh cao được công nhận là Bảo vật Quốc gia.'
  },
  {
    id: 1,
    title: 'Cánh cửa chạm rồng',
    en: 'A Pair of Dragon Doors',
    author: 'Không ghi nhận',
    material: 'Gỗ',
    code: '3',
    location: 'Phòng trưng bày Mỹ thuật cổ · Mẫu',
    stamp: '/images/generated/stamps-v5/stamp-canh-cua-cham-rong-v5.webp',
    source: 'https://vnfam.vn/vi/hiện-vật/5ab4abec9b6165001cd4f8d4',
    unlocked: true,
    story: 'Cặp cánh cửa gỗ nổi bật với hệ chạm khắc rồng, mây và các lớp hoa văn dày đặc từ thời Lê Trung Hưng. Kỹ thuật chạm khắc lộng tinh xảo, thể hiện quyền uy và sự linh thiêng trong mỹ thuật tôn giáo truyền thống.'
  },
  {
    id: 2,
    title: 'Bác Hồ ở chiến khu Việt Bắc',
    en: 'Uncle Ho in the Viet Bac War Zone',
    author: 'Dương Bích Liên',
    material: 'Sơn mài',
    code: '33',
    location: 'Phòng trưng bày Mỹ thuật hiện đại · Mẫu',
    stamp: '/images/generated/stamps-v5/stamp-bac-ho-viet-bac-v5.webp',
    source: 'https://vnfam.vn/vi/hiện-vật/5ab4a44eece044001fcee0c6',
    unlocked: false,
    story: 'Tác phẩm đặt hình tượng Bác Hồ trong không gian núi rừng Việt Bắc với bảng màu trầm ấm, bố cục khoáng đạt và nét cọ lắng đọng, truyền tải vẻ đẹp giản dị mà vĩ đại của vị lãnh tụ kính yêu giữa thiên nhiên cách mạng.'
  },
  {
    id: 3,
    title: 'Gióng',
    en: 'Gióng',
    author: 'Nguyễn Tư Nghiêm',
    material: 'Sơn mài',
    code: '53',
    location: 'Phòng trưng bày Mỹ thuật hiện đại · Mẫu',
    stamp: '/images/generated/stamps-v5/stamp-giong-v5.webp',
    source: 'https://vnfam.vn/vi/hiện-vật/5a8163a24f90780027f356fa',
    unlocked: true,
    story: 'Nguyễn Tư Nghiêm tái hiện hình tượng người anh hùng Phù Đổng Thiên Vương bằng ngôn ngữ tạo hình hiện đại lấy cảm hứng từ hoa văn Đông Sơn và điêu khắc đình làng, kết hợp với sắc đỏ, đen, vàng kinh điển của chất liệu sơn mài.'
  },
  {
    id: 4,
    title: 'Hai thiếu nữ và em bé',
    en: 'Two Young Women and a Child',
    author: 'Tô Ngọc Vân',
    material: 'Sơn dầu',
    code: '9',
    location: 'Phòng trưng bày Mỹ thuật hiện đại · Mẫu',
    stamp: '/images/generated/stamps-v5/stamp-hai-thieu-nu-em-be-v5.webp',
    source: 'https://vnfam.vn/vi/hiện-vật/5a7ab4d66b347c0109a34df6',
    unlocked: false,
    story: 'Một không gian sinh hoạt tao nhã với ba nhân vật trong tà áo dài truyền thống. Bố cục hình tam giác cổ điển, ánh nhìn ấm áp và nhịp điệu hài hòa tạo nên một biểu tượng cho vẻ đẹp dịu dàng của người phụ nữ Việt Nam thời kỳ đầu thế kỷ 20.'
  },
  {
    id: 5,
    title: 'Hoàng hậu Trịnh Thị Ngọc Trúc',
    en: 'Queen Trịnh Thị Ngọc Trúc',
    author: 'Không ghi nhận',
    material: 'Gỗ phủ sơn',
    code: '2',
    location: 'Phòng trưng bày Điêu khắc · Mẫu',
    stamp: '/images/generated/stamps-v5/stamp-hoang-hau-ngoc-truc-v5.webp',
    source: 'https://vnfam.vn/vi/hiện-vật/5a719e1b6e676301a26d01a4',
    unlocked: false,
    story: 'Pho tượng chân dung bằng gỗ phủ sơn thế kỷ 17 thể hiện Hoàng hậu Trịnh Thị Ngọc Trúc trong tư thế tọa thiền trang nghiêm với nhiều tầng lớp trang phục lộng lẫy và chi tiết hoa văn chạm lộng tinh xảo của thời Lê - Trịnh.'
  },
  {
    id: 6,
    title: 'Phật bà Quan âm',
    en: 'Statue of the Bodhisattva Avalokiteshvara',
    author: 'Không ghi nhận',
    material: 'Gỗ phủ sơn',
    code: '1',
    location: 'Phòng trưng bày Điêu khắc Phật giáo · Mẫu',
    stamp: '/images/generated/stamps-v5/stamp-phat-ba-quan-am-v5.webp',
    source: 'https://vnfam.vn/vi/hiện-vật/5a719d976e676301a26d01a1',
    unlocked: false,
    story: 'Tượng Quan Âm nghìn mắt nghìn tay được tạo tác bằng gỗ phủ sơn, nổi bật ở cấu trúc cân xứng hoàn hảo, hệ cánh tay tỏa rộng hình vầng hào quang và nét mặt từ bi bác ái, là đỉnh cao của điêu khắc gỗ cổ Việt Nam.'
  },
  {
    id: 7,
    title: 'Kết nạp Đảng ở Điện Biên Phủ',
    en: 'Party Admission Ceremony on the Dien Bien Phu Battlefield',
    author: 'Nguyễn Sáng',
    material: 'Sơn mài',
    code: '45',
    location: 'Phòng trưng bày Mỹ thuật hiện đại · Mẫu',
    stamp: '/images/generated/stamps-v5/stamp-ket-nap-dang-dien-bien-v5.webp',
    source: 'https://vnfam.vn/vi/hiện-vật/5a718bcd16f5bd004aa13b33',
    unlocked: false,
    story: 'Nguyễn Sáng khắc họa khoảnh khắc trang nghiêm của lễ kết nạp Đảng ngay tại chiến hào Điện Biên Phủ năm 1954 bằng kỹ thuật sơn mài cô đọng, giàu tính sử thi và tinh thần quật cường của những người chiến sĩ cách mạng.'
  },
  {
    id: 8,
    title: 'Em Thúy',
    en: 'Little Sister Thuy',
    author: 'Trần Văn Cẩn',
    material: 'Sơn dầu',
    code: '18',
    location: 'Phòng trưng bày Mỹ thuật hiện đại · Mẫu',
    stamp: '/images/generated/stamps-v5/stamp-em-thuy-v5.webp',
    source: 'https://vnfam.vn/vi/hiện-vật/5a61a3f99f1f592e7371ab12',
    unlocked: false,
    story: 'Bức chân dung bé gái 8 tuổi ngồi trên chiếc ghế mây đơn sơ được vẽ bằng chất liệu sơn dầu vào năm 1943. Đôi mắt trong sáng, biểu cảm thơ ngây và bảng màu tươi sáng mang đến cảm giác an nhiên và xúc động sâu sắc.'
  }
];
